import { Navigate, Route, Routes } from "react-router-dom";
import DashboardPage from "../pages/dashboard-page/DashboardPage";
import { useAppSelector } from "../../store/store";
import { Fragment } from "react/jsx-runtime";
import SetupPage from "../pages/setup-page/SetupPage";
import ProfileManagerPage from "../pages/profile-manager-page/ProfileManagerPage";
import ItemDatabasePage from "../pages/item-spawner-page/ItemDatabasePage";
import SettingsPage from "../pages/settings-page/SettingsPage";

const App = () => {
  const socketConnected = useAppSelector((s) => s.socket.isConnected);

  return (
    <Routes>
      {socketConnected && (
        <Fragment>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/item-database" element={<ItemDatabasePage />} />
          <Route path="/profile-manager" element={<ProfileManagerPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Fragment>
      )}
      {!socketConnected && (
        <Fragment>
          <Route path="/setup" element={<SetupPage />} />
          <Route path="*" element={<Navigate to="/setup" replace />} />
        </Fragment>
      )}
    </Routes>
  );
};

export default App;
